module.exports = __webpack_public_path__ + "img/norway-transport-accidents-female.ae2f661d.png";